/**
 * Medlemmar i medlemsförteckningen.
 *
 * Importen skriver firstName/lastName/legalEntity, men äldre data och
 * anspråksflödet kan bära ett enda `name`-fält. Vyerna läste bara de tre
 * första: en sådan medlem visades som "Ej registrerad" och fick ingen
 * radera-knapp, trots att raden hade e-post och telefon. Allt som visar
 * eller villkorar på en medlems identitet går genom de här två.
 */
export type MemberLike = {
  firstName?: string | null;
  lastName?: string | null;
  legalEntity?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  personalNumber?: string | null;
} | null | undefined;

const text = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

/** Visningsnamn: juridisk person, annars för- och efternamn, annars `name`, annars e-post. */
export function memberDisplayName(m: MemberLike): string {
  if (!m) return '';
  const full = `${text(m.firstName)} ${text(m.lastName)}`.trim();
  return text(m.legalEntity) || full || text(m.name) || text(m.email);
}

/** Finns det något alls som identifierar medlemmen? Styr radera-knappen och medlemsräkningen. */
export function hasAnyIdentity(m: MemberLike): boolean {
  if (!m) return false;
  return [m.firstName, m.lastName, m.legalEntity, m.name, m.email, m.personalNumber].some((v) => text(v) !== '');
}

/** "Anna Berg Svensson" → { firstName: "Anna Berg", lastName: "Svensson" }. Ett ord → bara förnamn. */
export function splitFullName(name: unknown): { firstName: string; lastName: string } {
  const parts = text(name).split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { firstName: '', lastName: '' };
  if (parts.length === 1) return { firstName: parts[0], lastName: '' };
  return { firstName: parts.slice(0, -1).join(' '), lastName: parts[parts.length - 1] };
}
